// Dependencies
import { lazy } from "react";

const config = {
  dashboard: {
    permissions: ["0999", "0900"],
    component: lazy(() => import("./app/dashboard")),
    label: "Dashboard",
    path: "/app",
    exact: true,
    icon: "bank",
  },
  compras: {
    permissions: ["0999", "0900", "0800", "0600"],
    component: lazy(() => import("./app/compras")),
    label: "Compras",
    path: "/app/compras",
    icon: "shopping",
  },
  pedidos: {
    permissions: ["0999", "0900", "0800"],
    component: lazy(() => import("./app/pedidos")),
    label: "Pedidos",
    path: "/app/pedidos",
    icon: "database",
  },
  repartos: {
    permissions: ["0999", "0900", "0800"],
    component: lazy(() => import("./app/repartos")),
    label: "Repartos",
    path: "/app/repartos",
    icon: "car",
  },
  margenes: {
    permissions: ["0999", "0900"],
    component: lazy(() => import("./app/margenes")),
    label: "Márgenes",
    path: "/app/margenes",
    icon: "control",
    noLinked: true,
  },
  comercial: {
    permissions: ["0999", "0900", "0800"],
    component: lazy(() => import("./app/comercial")),
    label: "Comercial",
    path: "/app/comercial",
    icon: "copyright",
    noLinked: true,
  },
  reportes: {
    permissions: ["0999", "0900", "0800", "0600"],
    component: lazy(() => import("./app/reportes")),
    label: "Reportes",
    path: "/app/reportes",
    icon: "copy",
    noLinked: true,
  },
  inventario: {
    permissions: ["0999", "0900", "0800"],
    component: lazy(() => import("./app/inventario")),
    label: "Inventario",
    path: "/app/inventario",
    icon: "carry-out",
    noLinked: true,
  },
  empleados: {
    permissions: ["0999", "0900"],
    component: lazy(() => import("./app/empleados")),
    label: "Empleados",
    path: "/app/empleados",
    icon: "smile",
    noLinked: true,
  },
  configuracion: {
    permissions: ["0999", "0900"],
    component: lazy(() => import("./app/configuracion")),
    label: "Configuración",
    path: "/app/configuracion",
    icon: "setting",
  },
};

export const configApp = Object.keys(config).map((key) => {
  return {
    key,
    ...config[key],
  };
});

export const paths = Object.keys(config).map((key) => {
  const { path, navPath, label, noLinked } = config[key];
  return {
    path,
    navPath: navPath || path,
    label,
    noLinked: noLinked || false,
  };
});
